<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Surat BPKB</h5>
            </template>
            <b-button class="mr-2 mb-2" variant="pgiBtn" name="suratBpkbDownloadBtn" @click="openSuratPeriode">
                <i class="fa fa-download mr-2"></i>
                Download Excel
            </b-button>
            <b-button class="mb-2" variant="pgiBtn" name="suratBpkbAddBtn" @click="inputSuratBpkb">
                <i class="fa fa-plus mr-2"></i>
                Request Baru
            </b-button>
            <hr>
            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row class="align-items-start justify-content-between">
                    <b-col md="12" lg="9">
                        <b-row>
                            <b-col >
                                <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal Request">
                                    <div class="d-flex align-items-center search-input-wrapper">
                                        <b-form-input
                                            v-model="input.filterFromDate" name="filterFromDate"
                                            id="filterDate"
                                            type="date"
                                        ></b-form-input>
                                        <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                        <b-form-input 
                                            v-model="input.filterToDate" name="filterToDate"
                                            type="date"
                                        ></b-form-input>
                                    </div>
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterJenis" label="Jenis Surat">
                                    <b-form-select v-model="input.filterJenisSurat" id="filterJenis" name="jenisSurat" :options="jenisSuratOption" value-field="id" text-field="name">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>Jenis Surat</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                                    <b-form-select v-model="input.filterStatus" id="filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12">
                                <div class="filter-btn-wrapper">
                                    <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                        Search 
                                    </b-button>
                                    <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="dataSuratBpkb" 
                :fields="fields"
                :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data surat BPKB untuk dicek.
                </template>
                <template v-slot:cell(tanggalRequest)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalRequest)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalRequest)}}</div>
                </template>
                <template v-slot:cell(tanggalSurat)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalSurat)}}</div>
                    <div class="text-muted small">
                        {{ row.item.tipeAlamat }}
                    </div>
                </template>
                <template v-slot:cell(jumlahCabang)="row">
                    <div class="text-right no-wrap">
                        <p class="mb-0">{{$helper.addThousandSeparator(row.item.jumlahCabang)}}</p>
                    </div>
                </template>
                <template v-slot:cell(totalSurat)="row">
                    <div class="text-right no-wrap">
                        <p class="mb-0">{{$helper.addThousandSeparator(row.item.totalSurat)}}</p>
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="primary" v-if="row.item.status == 'SEDANG DIKERJAKAN'">SEDANG DIKERJAKAN</b-badge>
                    <b-badge variant="warning" v-else-if="row.item.status == 'PENDING'">PENDING</b-badge>
                    <b-badge variant="success" v-else>SIAP CETAK</b-badge>  
                </template>
                <template v-slot:cell(jenis)="row">
                    <b-badge variant="dark" v-if="row.item.jenis == 'PERINGATAN'">{{ row.item.jenis }}</b-badge>
                    <b-badge variant="primary" v-else>{{ row.item.jenis }}</b-badge>   
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="cekSuratBpkbDetailBtn" >
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Surat BPKB sudah diset, dan akan dikerjakan subuh esok hari.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">SEDANG DIKERJAKAN</h6>
                <p class="smallText mb-0">Surat BPKB sedang dalam pembentukan.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">SIAP DICETAK</h6>
                <p class="smallText mb-0">Surat BPKB sudah selesai dibentuk dan dapat diunduh untuk dicetak.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-periode-search" title="Laporan BPKB Macet" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isLoading">
            <b-form id="periodeDownloadSuratForm" @submit.prevent="confirmPeriodeDownload">
                <div class="search-wrapper align-items-center justify-content-between">
                    <b-form-group
                        label="Keterlambatan H+"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >
                        <div class="d-flex search-input-wrapper input-small-wrapper">
                            <b-input-group>
                                <b-form-input class="mr-2"
                                    v-model="input.filterFromDays" name="filterFromDays"
                                    type="number" required
                                ></b-form-input>
                            </b-input-group>
                            <span class="d-flex align-items-center">s/d H+</span>
                            <b-input-group>
                                <b-form-input class="mr-2"
                                    v-model="input.filterToDays" name="filterToDays"
                                    type="number" required
                                ></b-form-input>
                            </b-input-group>
                        </div>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadBtn" :disabled="isLoading" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadBtn" :disabled="isLoading" type="submit" form="periodeDownloadSuratForm">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'daftar-surat-bpkb',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterFromDate: null,
                filterToDate: null,
                filterStatus: null,
                filterJenisSurat: null,
                //
                
                filterFromDays: null,
                filterToDays: null,

            },
            fields: [
                { key: "jenis", label: "Jenis Surat" },
                { key: "tanggalRequest", label: "Tgl. Request" },
                { key: "tanggalSurat", label: "Tgl. & Tujuan Surat" },
                { key: "jumlahCabang", label: "Jumlah Cabang" },
                { key: "totalSurat", label: "Total Surat" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            jenisSuratOption: [
                { id: 1, name: 'Peringatan'},
                { id: 2, name: 'Penarikan'},
            ],
            statusOption: [ 
                { id: 0, name: 'Pending' },
                { id: 1, name: 'Sedang Dikerjakan' },
                { id: 2, name: 'Siap Cetak' },
            ],
            dataSuratBpkb: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",
            //
            isLoading: false,
            filePathDownload: "",
        }
    }, 
    methods: {
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getDataSuratBpkb= this.$axios.get("surat-bpkb/"+this.query).then(response => {
                this.dataSuratBpkb = response.data.data
                this.updateTotalItem(response.data.total)
          
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getDataSuratBpkb]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Ambil Data Cek Gadai -----------------

        getDataSuratBpkb(){
            this.toggleBusy()
            this.dataCekGadai = []

            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) this.query = this.query + "&filterStartDate=" + this.input.filterFromDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) this.query = this.query + "&filterEndDate=" + this.input.filterToDate
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.filterJenisSurat != null) this.query = this.query + "&filterJenis=" + this.input.filterJenisSurat
            
            this.$axios.get("surat-bpkb/"+this.query).then(response => {
                this.dataSuratBpkb = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDataSuratBpkb()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDataSuratBpkb()
            }
        },

        onReset(){
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.input.filterStatus = null
            this.input.filterJenisSurat = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDataSuratBpkb()
        },

        onFilter(){

            if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.page = 0
                this.currentPage = 1
                this.query = this.$helper.makeQuery(0, this.size)
                this.loading = true
                this.getDataSuratBpkb()
            }
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputSuratBpkb(){
            this.$router.push({path: `${this.$route.path}/input`});
        },

        openSuratPeriode(){
            this.$bvModal.show('modal-periode-search')
        },

        confirmPeriodeDownload(){
            if(Number(this.input.filterToDays) < Number(this.input.filterFromDays)){
                this.$helper.toastErr(this, "Hari akhir lebih kecil daripada hari mulai!")
            }else{
                this.openSuratDownload()
            }
        },

        openSuratDownload(){
            this.isLoading = true
            this.$bvModal.hide('modal-periode-search')
            this.$bvModal.show('modal-download-excel')
            setTimeout(() => { this.axiosPeriodeDownload() }, 500)
        },

        axiosPeriodeDownload(){
            this.$axios.get(`surat-bpkb/excel/?hDari=${this.input.filterFromDays}&hSampai=${this.input.filterToDays}`).then(response => {
                this.filePathDownload = response.data
                this.input.filterFromDays = null
                this.input.filterToDays = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

    },

    created(){
        this.init()
    }
}
</script>
